export default __webpack_public_path__ + "static/media/space.a7146fef.wav";